module.exports = __webpack_public_path__ + "static/desktops-e0cd2aa21c7dd02531650d81f7946f08.png";